import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Modal from "../../UI/Modal";
import Nomenklatura from "./Nomenklatura";

const StyledSpeedDial = styled(SpeedDial)(({ theme }) => ({
  position: "absolute",
  "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  "&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight": {
    top: theme.spacing(2),
    left: theme.spacing(2),
  },
}));

export default function ActionsForNomenklatura({ item, updateChckedRow }) {
  const [openingModal, setOpeningModal] = React.useState(false);

  const editHandlerClick = () => {
    setOpeningModal(true);
  };

  const saveHandlerClick = () => {
    updateChckedRow(item, true)
  };
  const deleteHandlerClick = () => {
    updateChckedRow(item, false)
  };

  return (
    <Box sx={{ transform: "translateZ(0px)", flexGrow: 1 }}>
      <Box sx={{ position: "relative", height: 80 }}>
        <StyledSpeedDial
          ariaLabel="SpeedDial playground example"
          icon={<MoreHorizIcon />}
          direction="left"
        >
          <SpeedDialAction
            icon={<EditIcon />}
            name="Редактировать"
            onClick={editHandlerClick}
          />
          <SpeedDialAction
            icon={<SaveIcon />}
            name="Сохранить"
            onClick={saveHandlerClick}
          />
          <SpeedDialAction
            icon={<DeleteForeverIcon />}
            name="Удалить"
            onClick={deleteHandlerClick}
          />
        </StyledSpeedDial>
      </Box>
      <Modal
        fullwidth={"900px"}
        isOpen={openingModal}
        onClose={() => setOpeningModal(false)}
      >
        <Nomenklatura item={item.attributes} id={item.id} onClose={() => setOpeningModal(false)} />
      </Modal>
    </Box>
  );
}
